import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ErrorHandlerService } from 'app/shared/error-handler.service';
import { HttpUtils } from 'app/shared/http-utils';
import { catchError, Observable } from 'rxjs';
import { IMarkAsRead, INotification, INotificationRequest, NotificationType } from '../model/notifications.model';
import { FacetsResponse } from 'app/my-history/facet/facets-response';

@Injectable({
  providedIn: 'root',
})
export class NotificationsCrudService {
  private http = inject(HttpClient);
  private apiUrl = HttpUtils.getApiUrl('/notifications/v1');
  private errorService = inject(ErrorHandlerService);

  constructor() {}

  /**
   *
   * @param take
   * @param skip
   * @param viewed
   * @param handleable true for Review queue, and false for Activity Tabs
   * @returns
   */
  getNotifications({
    take = 20,
    skip = 0,
    handleable = false,
    actorId,
    handled,
    notificationType,
    viewed,
  }: INotificationRequest): Observable<FacetsResponse<INotification>> {
    let params = new HttpParams().set('take', take).set('skip', skip).set('handleable', handleable);
    if (actorId) {
      params = params.set('actorId', actorId);
    }
    if (handled !== null && handled !== undefined) {
      params = params.set('handled', handled);
    }
    if (notificationType) {
      params = params.set('notificationType', notificationType);
    }
    if (viewed !== null && viewed !== undefined) {
      params = params.set('viewed', viewed);
    }
    return this.http
      .get<FacetsResponse<INotification>>(`${this.apiUrl}/actions`, {
        params,
      })
      .pipe(catchError((err) => this.errorService.handle(err)));
  }

  getUnreadNotifications(): Observable<{ total: number; activity: number; handleable: number }> {
    return this.http
      .get<{ total: number; activity: number; handleable: number }>(`${this.apiUrl}/actions/unread`)
      .pipe(catchError((err) => this.errorService.handle(err)));
  }

  markAsRead(notifications: string[]): Observable<IMarkAsRead> {
    return this.http
      .put<IMarkAsRead>(`${this.apiUrl}/actions/mark-as-read`, { notifications })
      .pipe(catchError((err) => this.errorService.handle(err)));
  }

  markAsReadAll(): Observable<IMarkAsRead> {
    return this.http
      .put<IMarkAsRead>(`${this.apiUrl}/actions/mark-as-read-all`, {})
      .pipe(catchError((err) => this.errorService.handle(err)));
  }

  markAsHandled(id: string): Observable<void> {
    return this.http
      .patch<void>(`${this.apiUrl}/actions/${id}/mark-as-handled`, {})
      .pipe(catchError((err) => this.errorService.handle(err)));
  }
}
